import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'
import Con from '../../../static/config.json'

export default {
  data () {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      dateNow: this.dateMonth(new Date()),
      data_Expenses: '',
      data_list: [],
      data_month: '',
      pdf_url: baseUrl + 'pdf/expenses_pdf.php',
      excel_url: baseUrl + 'excel/expenses_excel.php',
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      sum_cash_amount: 0,
      sum_expense_amount: 0,
      sum_cheque_amount: 0
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getExpenses () {
      this.data_list = []
      this.$store.state.isLoading = true
      api.getExpend(
        {
          date: moment(this.dateNow).format('YYYY-MM-DD'),
          active_page: 1,
          per_page: 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_list = result.data.pagination
            this.data_Expenses = JSON.stringify(result.data)
            console.log(result.data)
            this.sum_cash_amount = result.data.sum_cash_amount
            this.sum_expense_amount = result.data.sum_expense_amount
            this.sum_cheque_amount = result.data.sum_cheque_amount
            this.data_month = this.monthYearFormat(this.dateNow)
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getExpenses()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/expend_report.js